import apiClient from '_shared/lib/api-client';

function pending(actionType) {
  return {
    type: actionType + '_PENDING'
  }
}

function rejected(actionType) {
  return {
    type: actionType + '_REJECTED'
  }
}

function resolved(actionType, state) {
  return {
    type: actionType,
    state: state
  }
}

export default (actionType, url) => {
  return (dispatch, getState) => {
    dispatch(pending(actionType));

    return apiClient.post(url, getState())
      .then((payload) => {
        dispatch(resolved(actionType, payload));
        return payload.response;
      })
      .catch((payload) => {
        dispatch(rejected(actionType));
        return payload;
      });
  }
};



/** WEBPACK FOOTER **
 ** ./src/_shared/actions/_base.js
 **/